namespace advisorop.components.servicer{

    
    export class ManagerListController {
        dg: DevExpress.ui.dxDataGridOptions;
        managers: domains.IManager[];

        static $inject = ["servicerService"];
        constructor(private servicerService: services.ServicerService) {
            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Managers"
                },
                bindingOptions: {
                    dataSource: "vm.managers"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no managers",
                allowColumnResizing: false,            
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "name", caption: "Manager Name", cellTemplate: "colFullName", sortIndex: 0, sortOrder: "asc" },
                    { dataField: "statusDescription", caption: "Status"},

                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", cssClass : "tblOverflow", width:"140" }
                ],
            };
        }s

        setManagerStatus(manager: domains.IManager) {

            let managerStatus: domains.Status;

            if (manager.status == domains.Status.ACTIVE)
                managerStatus = domains.Status.INACTIVE;
            else {
                managerStatus = domains.Status.ACTIVE;
            }

            this.servicerService.setManagerStatus(manager, managerStatus)
                .then(response => {
                    //var ind = this.firmProducts.indexOf(advisoryFirmProduct);
                    //if (ind >= 0) {
                    //    this.firmProducts.splice(ind, 1);
                    //}
                    toastr.success("Manager status successfully changed");
                    this.loadManagers();
                }, err => toastr.error("Manager status has not been changed. " + err.data));
        };

        deleteManager(manager: domains.IManager): void {

            if (!window.confirm(`Are you sure you wish to delete manager ${manager.id} - ${manager.name} ?`))
                return;
            
            this.servicerService.deleteManager(manager.id).
                then((response) => {

                    toastr.success("Manager deleted.");

                    var ind = this.managers.indexOf(manager);
                    if (ind >= 0) {
                        this.managers.splice(ind, 1);
                    }
                    this.loadManagers();
                }).
                catch(err => {
                    toastr.error("Cannot delete this manager!" + err.data);
                });
        };

        loadManagers(): void {
            this.servicerService.getManagers().
                then((response) => {
                    this.managers = response.data;
                    this.dg.dataSource = this.managers;
                }).
                catch(err => {
                    toastr.error("Cannot fetch managers for this advisory firm!");
                });
        };

        $onInit(): void {
            this.loadManagers();
        }
    }


    class ManagerList implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
            };
            this.controller = ManagerListController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/servicer-module/components/manager-list.html";
        }
    }
    angular.module(Constants.APP).component("managerList", new ManagerList());
}